export default {
    BASE_API: 'http://api.7113333.com'
}
